import React from "react"
import authentication from "@irati/auth"
import {Recognition} from "@irati/types"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import History, {historyContext} from "@irati/utils/history"
import tracking from "@irati-tracking/recognition/recognition"

import FormattedMessage, {injectIntl} from "@irati/utils/lang"
import RecognitionHubViews from "@irati/recognition/constants/hubViewTypes"
import {stopPropagationAndPrevent} from "@irati-web/wallet/src/utils/stopBubbleEvent"
import Tooltip, {Tip} from "../shared/Tooltip"
import {Wrapper} from "./styled"
import {getRewardRecognitionLink} from "../../utils/paths"

interface Props {
  item: Recognition
  viewType?: RecognitionHubViews
}
const RewardRecognitionAction: React.FC<Props> = (props, context) => {
  const {item, viewType} = props
  const userUUID = authentication.user().uuid
  const canReward = authentication.apps("wallet.flexiRewards.canRewardEmployees")
  const isUserRecognised = item.receivers?.results.some(({uuid}) => uuid === userUUID)
  const onClick = (ev: MouseEvent) => {
    stopPropagationAndPrevent(ev)
    tracking.clickRewardBtn(context.app, viewType)
    History.push(getRewardRecognitionLink(item), context, {scrollToTop: false})
  }
  if (!canReward || isUserRecognised || item.isEveryone) {
    return null
  }
  return (
    <Tooltip
      id="addRewardToRecognitionTip"
      placement="bottom"
      tip={
        <Tip id="addRewardToRecognitionTooltip">
          <FormattedMessage id="recognition.btn.addRewardTooltip" />
        </Tip>
      }>
      <Wrapper onClick={onClick}>
        <Icon icon={IconTypes.circleRewards} size={18} marginRight />
        <FormattedMessage id="recognition.btn.addReward" />
      </Wrapper>
    </Tooltip>
  )
}

RewardRecognitionAction.contextTypes = historyContext

export default injectIntl(RewardRecognitionAction)
